import useFormStore from '@/features/Registration/useFormStore';
import ABTestStore from '@/stores/abTestStore';
import { cachedSessionStorage } from '../cachedSessionStorage';

export interface AnalyticsContext {
  abTests: Record<string, any>;
  search: string;
  context: {
    campaign: Record<string, any>;
    email: string;
    userAgent: string;
    timestamp: string;
    url: string;
    pathname: string;
    referrer: string;
  };
}

export interface ContextDependencies {
  getABTests: () => Record<string, any>;
  getUserEmail: () => string;
  getUTMCampaign: () => Record<string, any>;
  getUserAgent: () => string;
  getLocation: () => {
    href: string;
    pathname: string;
  };
  getReferrer: () => string;
}

export function gatherAnalyticsContext(deps: ContextDependencies): AnalyticsContext {
  const campaign = deps.getUTMCampaign() || {};

  const searchParams = new URLSearchParams();
  for (const [key, value] of Object.entries(campaign)) {
    searchParams.set(`utm_${key}`, value as string);
  }

  const location = deps.getLocation();

  return {
    abTests: deps.getABTests(),
    search: searchParams.toString(),
    context: {
      campaign,
      email: deps.getUserEmail(),
      userAgent: deps.getUserAgent(),
      timestamp: new Date().toISOString(),
      url: location.href,
      pathname: location.pathname,
      referrer: deps.getReferrer(),
    },
  };
}

export function createAnalyticsContextDependencies(): ContextDependencies {
  return {
    getABTests: () => {
      try {
        return ABTestStore.getState().ABTestsValues;
      } catch {
        return {};
      }
    },
    getUserEmail: () => {
      try {
        const formStore = useFormStore.getState();
        return formStore.units?.email || formStore.register?.email || '';
      } catch {
        return '';
      }
    },
    getUTMCampaign: () => {
      try {
        return cachedSessionStorage.getUTM();
      } catch {
        return {};
      }
    },
    getUserAgent: () => navigator.userAgent,
    getLocation: () => ({
      href: window.location.href,
      pathname: window.location.pathname,
    }),
    getReferrer: () => document.referrer,
  };
}
